import { useNavigationGuardContext } from "@jugl-web/domain-resources/common/providers/NavigationGuardProvider";
import { MultiSectionLayout } from "@jugl-web/ui-components";
import { SideMenuLayout } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useLocalStorage } from "@jugl-web/utils/hooks/useStorage";
import { SHOW_CHAT_BOT_LOADER_SETTINGS_UPDATED_ALERT_KEY } from "@jugl-web/utils/storage";
import { FC, useState } from "react";
import { ReactComponent as DesktopIcon } from "./assets/desktop.svg";
import { ReactComponent as ExclamationMarkIcon } from "./assets/exclamation-mark.svg";
import { ReactComponent as InfoIcon } from "./assets/info.svg";
import { ReactComponent as PaintIcon } from "./assets/paint.svg";
import { WebChatBotAppearanceTab } from "./components/WebChatBotAppearanceTab";
import { WebChatBotGeneralInfoTab } from "./components/WebChatBotGeneralInfoTab";
import { WebChatBotInstallTab } from "./components/WebChatBotInstallTab";
import { WebChatBotAccountMenuTab } from "./types";

export const WebChatBotAccountScreen: FC = () => {
  const [selectedMenuTab, setSelectedMenuTab] =
    useState<WebChatBotAccountMenuTab>(WebChatBotAccountMenuTab.generalInfo);

  const [wasLoaderSettingsUpdated] = useLocalStorage(
    SHOW_CHAT_BOT_LOADER_SETTINGS_UPDATED_ALERT_KEY,
    false
  );

  const { requestNavigation } = useNavigationGuardContext();

  const { t } = useTranslations();

  return (
    <MultiSectionLayout
      leftSide={
        <div className="border-dark-200 jugl__custom-scrollbar h-full w-[320px] overflow-y-auto border-0 border-r border-solid py-10 px-4">
          <SideMenuLayout
            items={[
              {
                id: WebChatBotAccountMenuTab.generalInfo,
                label: t({
                  id: "client-support-page.general-info",
                  defaultMessage: "General Info",
                }),
                icon: <InfoIcon />,
              },
              {
                id: WebChatBotAccountMenuTab.chatAppearance,
                label: t({
                  id: "client-support-page.chat-appearance",
                  defaultMessage: "Chat Appearance",
                }),
                icon: <PaintIcon />,
              },
              {
                id: WebChatBotAccountMenuTab.install,
                label: t({
                  id: "client-support-page.install",
                  defaultMessage: "Install",
                }),
                icon: <DesktopIcon />,
                endSlotIcon: wasLoaderSettingsUpdated ? (
                  <ExclamationMarkIcon />
                ) : undefined,
              },
            ]}
            selectedItem={selectedMenuTab}
            onItemClick={(item) =>
              requestNavigation(() =>
                setSelectedMenuTab(item.id as WebChatBotAccountMenuTab)
              )
            }
          />
        </div>
      }
    >
      {selectedMenuTab === WebChatBotAccountMenuTab.generalInfo && (
        <WebChatBotGeneralInfoTab />
      )}
      {selectedMenuTab === WebChatBotAccountMenuTab.install && (
        <WebChatBotInstallTab />
      )}
      {selectedMenuTab === WebChatBotAccountMenuTab.chatAppearance && (
        <WebChatBotAppearanceTab />
      )}
    </MultiSectionLayout>
  );
};
